import { ProfileAccountInfo } from "api/interfaces/accountInterface.interface";
import { useQuery } from "react-query";
import { useAppSelector } from "redux/hooks";
import {
  CardData,
  CategoryDef,
  LegendType,
} from "api/interfaces/dashboardInterface.interface";
import ChartWrapper from "../graph/ChartWrapper";
import { useMemo } from "react";
import { getWidgetChannelLicense } from "api/widgetAPI";
import { getLegendForKey } from "utils/StatsUtil";
import { formatNumber } from "utils/functions";

export default function ChannelLicense(props: CardData) {
  const selectedAccount: ProfileAccountInfo = useAppSelector(
    (state) => state.accountSettings
  );
  const channelLicense = useQuery(
    ["channelLicense", selectedAccount.accountId],
    () => {
      return getWidgetChannelLicense(selectedAccount.accountId);
    },
    {
      retry: 0,
      refetchOnWindowFocus: false,
    }
  );
  const {data ,legend} = useMemo(() => {
    if (channelLicense.data) {
      const convertData = getLegendForKey(channelLicense.data.result, props.items ?? []);
      return {
        data: convertData,
        legend: convertData.map((item) => ({
          ...item,
          value: formatNumber(item.value),
        })),
      };
    }
    return {
      data: [],
      legend: [],
    };
  }, [props.items, channelLicense.data]);
  return (
    <ChartWrapper
      rows={data}
      items={props.items as CategoryDef[]}
      legend={legend}
      isLoading={channelLicense.isLoading}
    />
  );
}
